import {css} from "@emotion/react";
import {Col, Container, Row} from "@pg-design/grid";
import {flexAbsoluteCenter, h100, mb, mv, onDesktop} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader";
import {Highlight, Text} from "@pg-design/text";

import {withGTM} from "../../../../components/hoc/withGTM";
import {SimpleContainer} from "../../../../components/layout/SimpleContainer";
import {usePageview} from "../../../tracking/use_pageview";
import {useGetAuthorsQuery} from "../../api/get_authors";
import {HeadingWithDescription} from "../../components/header/HeadingWithDescription";
import {ExpertsList} from "../../components/press_office/ExpertsList";
import {PressOfficeBreadcrumbs} from "../../components/press_office/PressOfficeBreadcrumbs";
import {PressOfficeMediaBookCard} from "../../components/press_office/PressOfficeMediaBookCard";
import {PressOfficeMenu} from "../../components/press_office/PressOfficeMenu";

export const Experts = withGTM(() => {
    usePageview();
    const {data: experts} = useGetAuthorsQuery();

    return (
        <SimpleContainer>
            <Container as="article">
                <Row>
                    <Col>
                        <PressOfficeBreadcrumbs css={mv(2)} />
                    </Col>
                </Row>
                <HeadingWithDescription
                    heading="Nasi eksperci"
                    description="Poznaj nas zespół doświadczonych analityków rynku nieruchomości, którzy regularnie dzielą się swoją wiedzą i prognozami w czołowych mediach. Tworzymy rzetelne, oparte na danych analizy, które pomagają zrozumieć mechanizmy rynku mieszkaniowego – zarówno inwestorom, jak i osobom szukającym swojego miejsca do życia."
                />
                <Row>
                    <Col lg={5} md={4} sm={4}>
                        <PressOfficeMenu />
                    </Col>
                    <Col lg={11} md={8} sm={4} css={mb(5)}>
                        {experts ? (
                            <>
                                <ExpertsList experts={experts.results} css={mb(4)} />
                                <Text variant="body_copy_1">
                                    Masz pytania do naszego eksperta? Napisz na{" "}
                                    <Text variant="button_micro" align="center">
                                        <Highlight>
                                            <a href="mailto:pr@rynekpierwotny.pl">pr@&#8203;rynekpierwotny.pl</a>
                                        </Highlight>
                                    </Text>
                                </Text>
                            </>
                        ) : (
                            <div css={[flexAbsoluteCenter, h100]}>
                                <Loader />
                            </div>
                        )}
                        <div css={mobile}>
                            <PressOfficeMediaBookCard />
                        </div>
                    </Col>
                </Row>
            </Container>
        </SimpleContainer>
    );
});

const mobile = css`
    display: block;

    ${onDesktop(css`
        display: none;
    `)};
`;
